<template>
<div id="table">
  <!-- データテーブル -->
  <div class="table_wrapper" v-if="dataList && dataList.length > 0">
    <table>
      <thead>
        <tr>
          <th v-for="(column, index) in columnList" :key="index">{{ column.columnName }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(rowData, index) in dataList" :key ="index">
          <td v-for="(colData, index) in rowData" :key ="index">
            <span v-if="index===1" @click="edit(colData)"><a>{{ colData }}</a></span>
            <span v-else>{{ colData }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

</div>
</template>
<script>

export default {
  name: 'dd-table',
  components: {
  },
  props: {
    columnList: Array,
    dataList: Array,
    totalCount: Number,
    pageNo: Number,
    dataCount: Number,
    changeTbl: Boolean,
    columnDataList: [],
    orderCode: String
  },
  data () {
    return {
      // データ
      columnData: [],
      files: [],
      showModal: false,
      isNew: false,
      isDelete: false,
      errorMessage: {text: ''},
      validateErrorMessages: {CustomConstraint: ''}
    }
  },
  methods: {
    // getTableInfoAndAllData: function () {
    //   this.pageNo = this.$route.params.pageNo == null ? 1 : this.$route.params.pageNo
    //   this.dataCount = this.$route.params.dataCount == null ? 16 : this.$route.params.dataCount
    //   this.$emit('getTableInfoAndAllData', this.pageNo, this.dataCount)
    // },
    edit: function (colData) {
      this.$emit('confirm', colData)
    }
  }
}
</script>
<style lang="scss" scoped>
#table {
  height: 100%;
}
table {
  vertical-align: middle;
  table-layout: unset;
  th {
    background: #666;
    color: #FFF;
    width: auto;
  }
  td {
    width: auto;
    white-space: nowrap;
    a {
      color: blue;
    }
    a:hover {
      color: #ff4500;
      cursor: pointer;
    }
  }
}
.table_wrapper {
  overflow: auto;
  height: 95%;
  .main_btn {
    line-height: 22px;
    margin: 0 5px;
  }
  thead {
    tr {
      white-space: nowrap;
    }
  }
  th.func_th {
    width: 106px;
  }
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/order/OrderTable.vue